import values from 'lodash/fp/values'
import PropTypes from 'prop-types'


const constants = {
    DEFAULT: '',
    ERROR: 'Fetch/USER_APPS_ERROR',
    PENDING: 'Fetch/USER_APPS_PENDING',
    SUCCESS: 'Fetch/USER_APPS_SUCCESS'
}

export const types = PropTypes.oneOf(values(constants))

export default constants
